(function( $, window, document, undefined) {
    var FixedSidebarScroll = {
        init: function init(elem) {
            this.$sidebar = $( elem );
            this.$box = this.$sidebar.find('.sell-box');

            this.events();
        },

        handleScroll: function handleScroll(event) {
            if ($(window).innerWidth() <= 768) {
                if (this.$box.hasClass('is-fixed') || this.$box.hasClass('is-fixed-bottom')) {
                    this.$box.removeClass('is-fixed is-fixed-bottom');
                }

                return false;
            }

            var scrolledAmount = $(window).scrollTop();
            var sidebarTopDistance = this.$sidebar.offset().top - 10;
            var sideBarHeight = this.$sidebar.outerHeight();
            var boxHeight = this.$box.outerHeight();
            var sideBarGap = sideBarHeight - boxHeight;

            if( scrolledAmount >= sidebarTopDistance && scrolledAmount <= sidebarTopDistance + sideBarGap ) {
                this.$box.removeClass('is-fixed-bottom').addClass('is-fixed');
            } else if ( scrolledAmount  >= sidebarTopDistance + (sideBarGap) ) {
                this.$box.removeClass('is-fixed').addClass('is-fixed-bottom');
            } else {
                this.$box.removeClass('is-fixed is-fixed-bottom');
            }
        },

        events: function events() {
            var that = this;

            window.addEventListener('scroll', this.handleScroll.bind(this));
        }
    };

    $.fn.fixedSidebarScroll = function( options ) {
        return this.each(function() {
            var fixedSidebarScrollObj = Object.create( FixedSidebarScroll );
            fixedSidebarScrollObj.init(this);
        });
    };

})( jQuery, window, document );
